import { useState } from "react";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { EditorialMarquee } from "../components/EditorialMarquee";
import { TrustBadges } from "../components/TrustBadges";
import { Services } from "../components/Services";
import { Hospitals } from "../components/Hospitals";
import { HowItWorks } from "../components/HowItWorks";
import { Manifesto } from "../components/Manifesto";
import { TrustJaipur } from "../components/TrustJaipur";
import { Contact } from "../components/Contact";
import { FAQ } from "../components/FAQ";
import { Associates } from "../components/Associates";
import { Footer } from "../components/Footer";
import { BookingDialog } from "../components/BookingDialog";
import { ConsultantNow } from "../components/ConsultantNow";

export default function Home() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const [initPriority, setInitPriority] = useState(false);
  const openBooking = () => { setInitPriority(false); setBookingOpen(true); };
  const openPriority = () => { setInitPriority(true); setBookingOpen(true); };

  return (
    <div className="bg-brand-cream min-h-screen">
      <Navbar onBook={openBooking} />
      <Hero onBook={openBooking} onPriority={openPriority} />
      <EditorialMarquee />
      <TrustBadges />
      <Services onBook={openBooking} />
      <Hospitals onBook={openBooking} />
      <HowItWorks onBook={openBooking} />
      <Manifesto />
      <TrustJaipur />
      <FAQ />
      <Associates />
      <Contact onBook={openBooking} />
      <Footer onBook={openBooking} />
      <BookingDialog open={bookingOpen} onOpenChange={setBookingOpen} initialPriority={initPriority} />
      <ConsultantNow />
    </div>
  );
}
